import Swal from 'sweetalert2'

function showDialog(type, title, message, callback) {
    Swal.fire({
        title: title,
        text: message,
        icon: type,
    }).then((result) => {
        if (result.isConfirmed && callback) {
            callback();
        }
    });

    /*swal({
        title: title,
        text: message,
        type: type,
        showCancelButton: false,
        confirmButtonColor: "#1d92f3",
        confirmButtonText: "Ok",
        closeOnConfirm: false
    }, function () {
        swal.close();

        if (callback) {
            callback();
        }
    });*/
}

function confirmDialog(title, message, callback) {
    Swal.fire({
        title: title,
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1d92f3',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        cancelButtonText: "Cancel",
    }).then((result) => {
        if (result.isConfirmed && callback) {
            callback();
        }
    });

    /*swal({
        title: title,
        text: message,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Huỷ",
        closeOnConfirm: false
    }, function () {
        swal.close();

        if (callback) {
            callback();
        }
    });*/
}

function inputDialog(title, message, input_value, callback) {
    swal({
        title: title,
        text: message,
        type: "input",
        inputValue: input_value,
        showCancelButton: true,
        closeOnConfirm: false,
        animation: "slide-from-top",
        inputPlaceholder: "Nội dung",
        cancelButtonText: "Huỷ",
        confirmButtonText: "Cập nhật",
    }, function (inputValue) {
        if (inputValue === false) return false;
        if (inputValue === "") {
            swal.showInputError("Vui lòng nhập nội dung!");

            return false
        }

        swal.close();

        if (callback) {
            callback(inputValue);
        }
    });
}

function selectDialog(title, message, input_value, callback) {
    swal({
        title: title,
        text: message,
        input: 'select',
        inputOptions: {
            'SRB': 'Serbia',
            'UKR': 'Ukraine',
            'HRV': 'Croatia'
        },
        inputValue: 'HRV',
        showCancelButton: true,
        closeOnConfirm: false,
        animation: "slide-from-top",
        inputPlaceholder: "Chọn ...",
        cancelButtonText: "Huỷ",
        confirmButtonText: "Cập nhật",
    }, function (inputValue) {
        if (inputValue === false) return false;
        if (inputValue === "") {
            swal.showInputError("Vui lòng nhập nội dung!");

            return false
        }

        swal.close();

        if (callback) {
            callback(inputValue);
        }
    });
}
function showDepositStatus(type, title, message, imgUrl, screen, callback) {
    Swal.fire({
        title: title[0],
        text: message[0],
        icon: type,
        timer: 3100,
        imageUrl: imgUrl[0],
        padding: 2.4,
        heightAuto: false,
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
            image: 'img-dialog',
            title: 'title-dialog',
            closeButton: 'close-dialog-btn',
        }
    })
    .then((result) => {
        setTimeout(function(){
            Swal.fire({
                title: title[1],
                text: message[1],
                icon: type,
                imageUrl: imgUrl[1],
                showCancelButton: false,
                showConfirmButton: true,
                showDenyButton: true,
                padding: 2.4,
                heightAuto: false,
                showCloseButton: true,
                confirmButtonText: `Tôi cần hỗ trợ`,
                denyButtonText: `Kiểm tra lại`,
                customClass: {
                    image: 'img-dialog',
                    title: 'title-dialog',
                    closeButton: 'close-dialog-btn',
                    confirmButton: 'btn-normal-blue',
                    denyButton: 'btn-normal-blur',
                }

            }).then((result) => {
                if (result.isConfirmed && callback) {
                    callback();
                }else if(result.isDenied){
                    showDepositStatus(type, title, message, imgUrl, screen, callback)
                }
            });
        },100);

    })
}
// function showDepositStatus(type, title, message, imgUrl, screen, callback) {
//
// }
function showDepositConfirmed(type, title, message, imgUrl, screen, callback) {
    Swal.fire({
        title: title[2],
        text: message[2],
        icon: type,
        imageUrl: imgUrl[2],
        padding: 2.4,
        heightAuto: false,
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
        confirmButtonText: `Đóng`,
        customClass: {
            image: 'img-dialog',
            title: 'title-dialog',
            closeButton: 'close-dialog-btn',
            confirmButton: 'close-dialog-btn',
            cancelButton: 'btn-normal-blur',
        }
    }).then((result) => {
        if (Swal.DismissReason.close && callback) {
            callback();
        }
    });
}
function closeCurrentDialog(){
    Swal.close();
    setTimeout(function(){
        Swal.clickCancel();
    },3000)
}
export {
    showDialog,
    confirmDialog,
    inputDialog,
    selectDialog,
    showDepositStatus,
    closeCurrentDialog,
    showDepositConfirmed
}
